export default __webpack_public_path__ + "e5cc13bf01421ba8a3b58c3605b11e6d.svg";